/* =========================================================
   MG SIZE CHART — popup behaviour
   Loaded by snippets/mg-size-chart.liquid.

   - Opens / closes the modal ([data-mg-sc-open] / [data-mg-sc-close], Esc)
   - Builds the size table from the chart data (JSON printed by Liquid)
   - Measurements are entered in INCHES only; cm values are calculated
     here (inch x 2.54, rounded to the nearest whole cm)
   - IN / CM toggle, remembered for the visitor's next visit
   - "Find your size": type a measurement, get the size, highlight its column
   ========================================================= */
(function () {
  'use strict';

  // The snippet can be rendered more than once on a page; run this file once.
  if (window.mgSizeChart) return;

  var MG_SC_UNIT_KEY = 'mg-sc-unit';
  var MG_SC_CM = 2.54;
  var mgScUnitMemory = 'in';
  var mgScLastFocus = null;

  /* ---------- helpers ---------- */

  function mgScGetUnit() {
    try {
      var saved = window.localStorage.getItem(MG_SC_UNIT_KEY);
      if (saved === 'in' || saved === 'cm') return saved;
    } catch (e) {}
    return mgScUnitMemory;
  }

  function mgScSetUnit(unit) {
    mgScUnitMemory = unit;
    try { window.localStorage.setItem(MG_SC_UNIT_KEY, unit); } catch (e) {}
  }

  function mgScEscape(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  // Accepts a metafield list (array) or a single comma separated line.
  function mgScToList(value) {
    if (Array.isArray(value)) return value.map(function (v) { return String(v == null ? '' : v).trim(); });
    if (typeof value === 'string' && value.trim() !== '') {
      return value.split(/[,;\n|]+/).map(function (v) { return v.trim(); });
    }
    return [];
  }

  // "28-30", "28 to 30", "28 – 30" -> [28, 30];  "30" -> [30, 30];  "" -> null
  function mgScParseRange(text) {
    var found = String(text == null ? '' : text).replace(/,/g, '.').match(/\d+(\.\d+)?/g);
    if (!found) return null;
    var a = parseFloat(found[0]);
    var b = found.length > 1 ? parseFloat(found[1]) : a;
    return a <= b ? [a, b] : [b, a];
  }

  function mgScNumber(n) {
    return String(Math.round(n * 100) / 100);
  }

  function mgScFormat(range, unit) {
    if (!range) return '&ndash;';
    var a = unit === 'cm' ? Math.round(range[0] * MG_SC_CM) : range[0];
    var b = unit === 'cm' ? Math.round(range[1] * MG_SC_CM) : range[1];
    return a === b ? mgScNumber(a) : mgScNumber(a) + '-' + mgScNumber(b);
  }

  // Fills [size] / [smaller] (bold) and [measure] / [unit] placeholders.
  function mgScFill(template, map) {
    var html = mgScEscape(template);
    Object.keys(map).forEach(function (key) {
      var bold = key === 'size' || key === 'smaller';
      var value = mgScEscape(map[key]);
      html = html.split('[' + key + ']').join(bold ? '<b>' + value + '</b>' : value);
    });
    return html;
  }

  /* ---------- chart data ---------- */

  function mgScGetChart(modal) {
    if (modal.mgScChart !== undefined) return modal.mgScChart;
    var chart = null;
    var dataEl = modal.querySelector('[data-mg-sc-data]');
    try {
      var raw = JSON.parse(dataEl.textContent);
      var sizes = mgScToList(raw.sizes).filter(function (s) { return s !== ''; });
      var rows = [];
      (raw.rows || []).forEach(function (row, index) {
        if (!row || !row.label) return;
        var values = mgScToList(row.values);
        var ranges = sizes.map(function (size, i) { return mgScParseRange(values[i]); });
        if (!ranges.some(function (r) { return r; })) return;
        rows.push({ number: index + 1, label: String(row.label), ranges: ranges });
      });
      if (sizes.length && rows.length) {
        var wanted = parseInt(raw.finder, 10) || 1;
        var finder = rows.filter(function (r) { return r.number === wanted; })[0] || rows[0];
        chart = { sizes: sizes, rows: rows, finder: finder, text: raw.text || {} };
      }
    } catch (e) {
      chart = null;
    }
    modal.mgScChart = chart;
    return chart;
  }

  /* ---------- render ---------- */

  function mgScRender(modal) {
    var chart = mgScGetChart(modal);
    var chartBox = modal.querySelector('[data-mg-sc-chart]');
    if (!chart) {
      if (chartBox) chartBox.hidden = true;
      return;
    }

    var unit = mgScGetUnit();
    var text = chart.text;
    var unitName = unit === 'cm' ? (text.cm || 'cm') : (text.inches || 'inches');

    var html = '<thead><tr><th scope="col">' + mgScEscape(text.sizeCol || 'Size') + '</th>' +
      chart.sizes.map(function (s) { return '<th scope="col">' + mgScEscape(s) + '</th>'; }).join('') +
      '</tr></thead><tbody>';
    chart.rows.forEach(function (row) {
      html += '<tr><th scope="row">' + mgScEscape(row.label) + '</th>' +
        row.ranges.map(function (r) { return '<td>' + mgScFormat(r, unit) + '</td>'; }).join('') + '</tr>';
    });
    modal.querySelector('[data-mg-sc-table]').innerHTML = html + '</tbody>';

    modal.querySelectorAll('[data-mg-sc-uname]').forEach(function (el) { el.textContent = unitName; });

    var note = modal.querySelector('[data-mg-sc-unitnote]');
    if (note) note.innerHTML = mgScFill(text.unitNote || '', { unit: unitName });

    var label = modal.querySelector('[data-mg-sc-finder-label]');
    if (label) label.innerHTML = mgScFill(text.finderLabel || '', { measure: chart.finder.label.toLowerCase() });

    modal.querySelectorAll('[data-mg-sc-unit]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.getAttribute('data-mg-sc-unit') === unit ? 'true' : 'false');
    });

    // Keep what the visitor typed, converted to the new unit.
    var input = modal.querySelector('[data-mg-sc-input]');
    if (input) {
      var previous = input.getAttribute('data-mg-sc-input-unit');
      if (previous && previous !== unit && input.value !== '') {
        var typed = parseFloat(String(input.value).replace(',', '.'));
        if (!isNaN(typed)) {
          input.value = String(Math.round((unit === 'cm' ? typed * MG_SC_CM : typed / MG_SC_CM) * 2) / 2);
        }
      }
      input.setAttribute('data-mg-sc-input-unit', unit);
      mgScFind(modal);
    }
  }

  /* ---------- find your size ---------- */

  function mgScFind(modal) {
    var chart = mgScGetChart(modal);
    var input = modal.querySelector('[data-mg-sc-input]');
    var output = modal.querySelector('[data-mg-sc-output]');
    if (!chart || !input || !output) return;

    modal.querySelectorAll('.mg-sc-hit').forEach(function (el) { el.classList.remove('mg-sc-hit'); });

    var text = chart.text;
    var measure = chart.finder.label.toLowerCase();
    var value = parseFloat(String(input.value).replace(',', '.'));
    if (input.value === '' || isNaN(value)) {
      output.innerHTML = mgScFill(text.empty || '', { measure: measure });
      return;
    }

    var inches = input.getAttribute('data-mg-sc-input-unit') === 'cm' ? value / MG_SC_CM : value;

    // Only sizes that have a value in the finder row take part.
    var cols = [];
    chart.finder.ranges.forEach(function (r, i) { if (r) cols.push({ index: i, min: r[0], max: r[1] }); });

    var hit = -1;
    var between = false;
    for (var i = 0; i < cols.length; i++) {
      if (inches <= cols[i].max + 0.0001) {
        hit = i;
        between = inches < cols[i].min - 0.0001;
        break;
      }
    }

    if (inches < cols[0].min - 1) {
      hit = 0;
      output.innerHTML = mgScFill(text.below || '', { size: chart.sizes[cols[0].index], measure: measure });
    } else if (hit < 0) {
      output.innerHTML = mgScFill(text.above || '', { measure: measure });
      return;
    } else if (between && hit > 0) {
      output.innerHTML = mgScFill(text.between || '', {
        size: chart.sizes[cols[hit].index],
        smaller: chart.sizes[cols[hit - 1].index],
        measure: measure
      });
    } else {
      output.innerHTML = mgScFill(text.match || '', { size: chart.sizes[cols[hit].index], measure: measure });
    }

    // +1 because the first column of every row is the row label.
    var column = cols[hit].index + 1;
    modal.querySelectorAll('[data-mg-sc-table] tr').forEach(function (tr) {
      var cell = tr.children[column];
      if (cell) cell.classList.add('mg-sc-hit');
    });
  }

  /* ---------- open / close ---------- */

  function mgScOpen(id) {
    var modal = document.getElementById(id);
    if (!modal) return;

    // Move the modal to <body> so no parent (overflow, transform, z-index)
    // can clip it. In the theme editor a section re-render leaves the old
    // copy behind in <body>; remove it and use the fresh one.
    document.querySelectorAll('[data-mg-sc]').forEach(function (el) {
      if (el !== modal && el.id === id) el.parentNode.removeChild(el);
    });
    if (modal.parentNode !== document.body) document.body.appendChild(modal);

    mgScLastFocus = document.activeElement;
    mgScRender(modal);
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';

    var closeBtn = modal.querySelector('.mg-sc__close');
    if (closeBtn) closeBtn.focus();
  }

  function mgScClose(modal) {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.documentElement.style.overflow = '';
    if (mgScLastFocus && mgScLastFocus.focus && document.contains(mgScLastFocus)) mgScLastFocus.focus();
    mgScLastFocus = null;
  }

  function mgScOpenModals() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-mg-sc]:not([hidden])'));
  }

  /* ---------- events (delegated, so theme editor re-renders keep working) ---------- */

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-mg-sc-open]');
    if (opener) {
      e.preventDefault();
      mgScOpen(opener.getAttribute('data-mg-sc-open'));
      return;
    }

    var closer = e.target.closest('[data-mg-sc-close]');
    if (closer) {
      mgScClose(closer.closest('[data-mg-sc]'));
      return;
    }

    var unitBtn = e.target.closest('[data-mg-sc-unit]');
    if (unitBtn) {
      mgScSetUnit(unitBtn.getAttribute('data-mg-sc-unit') === 'cm' ? 'cm' : 'in');
      mgScOpenModals().forEach(mgScRender);
    }
  });

  document.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('[data-mg-sc-input]')) return;
    mgScFind(e.target.closest('[data-mg-sc]'));
  });

  document.addEventListener('keydown', function (e) {
    var open = mgScOpenModals();
    if (!open.length) return;

    if (e.key === 'Escape' || e.key === 'Esc') {
      open.forEach(mgScClose);
      return;
    }

    // Keep keyboard focus inside the open popup.
    if (e.key === 'Tab') {
      var modal = open[open.length - 1];
      var items = Array.prototype.slice.call(
        modal.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])')
      ).filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (!modal.contains(document.activeElement)) {
        e.preventDefault();
        first.focus();
      } else if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  window.mgSizeChart = {
    open: mgScOpen,
    close: function (id) { mgScClose(document.getElementById(id)); }
  };
})();
